import React, { Component } from 'react';
import { Header, List } from 'semantic-ui-react';

export default class ReadingCommentariesPage extends Component {
  render() {
    return (
      <div>
        <Header as="h1" content="Reading commentaries" />
        <p>
          Every lecture has two associated readings. If you plan on attending lecture,
          your reading commentary should consist of three questions / discussion prompts.
          If you must be absent from a lecture, your reading commentary should one to three
          paragraphs. More detail in the corresponding sections below.
        </p>

        <Header as="h2" content="Questions / discussion prompts" />
        <p>
          <strong>
            If you are attending class for the corresponding lecture,
          </strong>
          you should write down three questions / discussion prompts for each of the readings.
        </p>

        <p>
          Discussion prompts should be 
          <i>
            open-ended
          </i>
          and not answerable with a simple yes/no or gathering of facts from the paper.
          For example, do not ask "Did the authors appropriately compensate participants?";
          rather, ask "The compensation appears to be under minimum-wage; how might that
          compensation level have affected the participants the authors could recruit for the study?"
        </p>

        <p>
          Moreover, these prompts should
          <i>
            demonstrate an understanding of the reading.
          </i>
          In other words, they should not be generic enough to apply to every reading.
          So, instead of asking:
          "What can we build based on the findings?", ask:
          "The paper demonstrates that people are frustrated, but helpless, with their lack of control over their personal data.
           Do we need stronger regulations or better systems or both to solve this problem?"
        </p>


        <Header as="h2" content="Full commentaries" />
        <p>
          <strong>
            If you are going to be absent for the corresponding lecture,
          </strong>
          you should write a full commentary for each of the readings of that lecture.
        </p>

        <p>
          The goal of full reading commentaries are twofold: to give you an opportunity to practice
          (i) thinking critically about research or key concepts in usable privacy and security;
          and, (ii) communicating your thoughts about how to build on existing usable privacy
          and security research.  The goal is not to summarize the paper — everyone reading
          your commentary will have already read the paper!
        </p>

        <p>
          Some appropriate topics to address in a commentary are:
        </p>

        <List bulleted>
          <List.Item>
            future research directions that this reading inspires for you
          </List.Item>
          <List.Item>
            why the reading does/doesn't seem important
          </List.Item>
          <List.Item>
            observations of novel methodology or methodology that seems suspect
          </List.Item>
          <List.Item>
            why the reading is/isn't effective at getting its message across
          </List.Item>
          <List.Item>
            how the reading has changed your opinion or outlook on a topic
          </List.Item>
        </List>

        <p>
          An excellent way to structure your commentary is to discuss two "positive"
          topics and one "criticism" for each reading (or two "I like"s and one "I wish").
          Each topic should be a short paragraph (about 2-4 sentences in length).
        </p>

        <Header as="h2" content="Deliverable" />
        <p>
          You should write a commentary for <b>each required assigned reading</b> (there are
          two per class) starting from the 1/18 lecture.
        </p>
        <p>
          Commentaries are due at <strong>11:59pm the night before</strong> the class in which the reading is scheduled to be discussed.
          Commentaries should be submitted as replies to the thread with the reading’s title on
          Canvas. You will be able to see other students’ commentaries once you have posted your
          own. Reading commentaries are required for each assigned reading (there are two per class).
        </p>

        <Header as="h2" content="Grading" />
        <p>
          You will be assigned a reading commentary grade for each class (thus, the two
          commentaries you submit for a particular class will be graded together).
        </p>

        <p>
          Commentaries will be graded either as a check, check-plus or check-minus, according
          to the following rubric:
        </p>

        <List bulleted>
          <List.Item>
            <b>Check Plus:</b> The commentary is very detailed and engages with the intellectual
            content of the reading deeply.
          </List.Item>
          <List.Item>
            <b>Check:</b> The commentary is sufficiently detailed and engages with
            the intellectual content of the reading at a moderate level.
          </List.Item>
          <List.Item>
            <b>Check Minus:</b> The commentary is innaccurate, shallow or insufficiently detailed.
          </List.Item>
        </List>

        <p>
          If you only get "checks", you will end up with a 90. The more "check pluses" you get,
          the higher your grade. Likewise, the more "check minuses", the lower your grade.
          For class periods where a classmate is leading the discussion, they will be the one
          assigning your grade. For other classes, it will be me. Your two lowest grades will
          be dropped in calculating your final score.
        </p>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/reading-commentaries-page.js